const AUTOMOTIVE_INITIALISMS = new Map([
  ["gr", "GR"],
  ["gr86", "GR86"],
  ["bmw", "BMW"],
  ["gt-r", "GT-R"],
  ["mx-5", "MX-5"],
  ["wrx", "WRX"],
  ["amg", "AMG"]
]);

export function formatVehicleDisplayText(value) {
  return String(value || "")
    .split(/(\s+)/)
    .map((part) => AUTOMOTIVE_INITIALISMS.get(part.toLowerCase()) || part)
    .join("")
    .trim();
}

export function getGarageVehicleTitle(car = {}) {
  const title = [car.year, car.make, car.model, car.trim]
    .map(formatVehicleDisplayText)
    .filter(Boolean)
    .join(" ");

  return title || formatVehicleDisplayText(car.name) || "Untitled vehicle";
}

export function getCurrentGaragePhase(car = {}) {
  return car.stages?.find((stage) => stage.id === car.currentStageId) || car.stages?.[0] || null;
}

export function getGarageCoverImage(car = {}) {
  const phase = getCurrentGaragePhase(car);
  return phase?.coverPhoto || phase?.coverImage || phase?.images?.[0] || car.coverPhoto || car.coverImage || car.images?.[0] || "";
}

export function getGaragePhaseName(car = {}) {
  const phaseName = getCurrentGaragePhase(car)?.name;
  return phaseName === "Current Build" ? "Original Build" : phaseName || "Original Build";
}

export function getGarageUpdatedLabel(car = {}) {
  const phase = getCurrentGaragePhase(car);
  const date = parseDisplayDate(phase?.updatedAt || car.lastUpdated || car.updatedAt);
  if (!date) return "";
  return `Updated ${date.toLocaleDateString(undefined, { month: "long", day: "numeric" })}`;
}

function parseDisplayDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") {
    const date = value.toDate();
    return Number.isNaN(date?.getTime?.()) ? null : date;
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
